// dashboard.js
import {loading, errors, loadingBtn, remove, meta,directLoading, step, controller} from "./shared";

export default function useDashboard() {
  const route = useRoute();
  const router = useRouter();
  const navigation = { route, router };
  const auth = useAuth(navigation);
  const user = useUser(navigation);
  const role = useRole(navigation);
  const clue = useClue(navigation);
  const account = useAccount(navigation);
  const appointment = useAppointment(navigation);
  const person = usePerson(navigation);
  const campaign = useCampaign(navigation);
  const CampaignType = useCampaignType(navigation);
  const opportunity = useOpportunity(navigation);
  const ticket = useTicket(navigation);
  const upload = useUpload(navigation);
  const message = useMessage(navigation);
  const saveMessage = useSaveMessage(navigation);
  const industry = useIndustry(navigation);
  const saleRoute = useSaleRoute(navigation);
  const leadSource = useLeadSource(navigation);
  const failureReason = useFailureReason(navigation);
  const productCategory = useProductCategory(navigation);
  const product = useProduct(navigation);
  const discount = useDiscount(navigation);
  const invoice = useInvoice(navigation);
  const payment = usePayment(navigation);
  const other = useOther(navigation);

  return {
    ...auth,
    ...user,
    ...role,
    ...clue,
    ...account,
    ...appointment,
    ...person,
    ...campaign,
    ...CampaignType,
    ...opportunity,
    ...ticket,
    ...upload,
    ...message,
    ...saveMessage,
    ...industry,
    ...saleRoute,
    ...leadSource,
    ...failureReason,
    ...productCategory,
    ...product,
    ...discount,
    ...invoice,
    ...payment,
    ...other,
    loading,
    router,
    route,
    meta,
    loadingBtn,
    directLoading,
    remove,
    errors,
    step,
    controller,
  };
}
